<template>
  <div class="layout">
    <div class="sidenav" :style="{height:side_height+'px'}">
      <SideNav></SideNav>
      <div class="clear">
      </div>
    </div>
    <div class="container" :style="{width:container_width+'px'}">
      <div class="topnav" >
        <TopNav :router_matched="router_matched"></TopNav>
      </div>
	  <!-- 标签页 -->
	  <div class="tagview" style="margin-top: 20px;">
	    <TagView :router_matched="router_matched"></TagView>
	  </div>

      <div class="main" :style="{width:container_width-80+'px',height:main_height-96+'px'}">
        <div>
          <Main></Main>
        </div>
      </div>

      <div class="footer">
        <Footer></Footer>
      </div>
    </div>

    <div class="clear"> </div>


  </div>
</template>

<script>
    import SideNav from "@/layout/SideNav.vue"
    import TagView from "@/layout/TagView.vue"
    import TopNav from "@/layout/TopNav.vue"
    import Footer from "@/layout/Footer.vue"
    import Main from "@/layout/Main.vue"
    import BreadCrumb from "@/layout/BreadCrumb.vue"
    export default {
        name: "Layout",
        components: {
            SideNav,
            TagView,
            TopNav,
            Footer,
            Main,
            BreadCrumb,
        },
        data(){
            return{
                side_height:document.documentElement.clientHeight,
                main_height:document.documentElement.clientHeight-130,
                container_width:document.documentElement.clientWidth-220, // （郑保坤）把202改成220，不然模态框如果有文本域和地图会错位。
            }
        },
        mounted () {
            window.addEventListener('resize', () => {
                this.side_height=document.documentElement.clientHeight;
                this.main_height=document.documentElement.clientHeight-130;
                this.container_width=document.documentElement.clientWidth-220;// （郑保坤）把202改成220，不然模态框如果有文本域和地图会错位。
            })

        },
        computed: {
            router_matched () {
				// console.log(this.$route.matched);
                return this.$route.matched
            }
        }


    }
</script>

<style>

</style>